/*
 * @Author: your name
 * @Date: 2021-07-13 19:39:49
 * @LastEditTime: 2023-10-23 10:35:49
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\api\user\index.js
 */
import request from '../request';

const urlPre = '/standard';
const baseUrl = request.getBaseUrl();
const server = {
  // 分页查询我的产品质量评价申请
  queryEvaluationApplyPageList(params) {
    return request.post(
      `${urlPre}/evaluation/evaluationApply/queryEvaluationApplyPageList`,
      params
    );
  },
  // 获取评价申请协议列表
  queryCommissionAttachmentList(params) {
    return request.post(
      `${urlPre}/evaluation/commissionAttachment/queryCommissionAttachmentList`,
      params
    );
  },
  // 获取回显发票
  queryByApplyId(params) {
    return request.post(
      `${urlPre}/evaluation/evaluateApplyInvoice/queryByApplyIdForDetail`,
      params
    );
  },
  // 新增发票
  addInvoice(params) {
    return request.post(`/user-center/invoice/add`, params);
  },
  // 删除发票
  deleteInvoice(params) {
    return request.post(`/user-center/invoice/batchDelete`, params);
  },
  // 修改发票
  modifyInvoice(params) {
    return request.post(`/user-center/invoice/modify`, params);
  },
  // 获取回显发票邮寄地址
  queryInvoiceAddressByApplyId(params) {
    return request.post(
      `${urlPre}/evaluation/memberAddress/queryByApplyIdForDetail`,
      params
    );
  },
  // 新增发票邮寄地址
  addInvoiceAddress(params) {
    return request.post(`/user-center/address/add`, params);
  },
  // 删除发票邮寄地址
  deleteInvoiceAddress(params) {
    return request.post(`/user-center/address/batchDelete`, params);
  },
  // 获取地区信息
  queryByParentId(params) {
    return request.post('/user-center/area/queryByParentId', params);
  },
  // 委托协议下载
  downloadEvaluationCommission(params) {
    return request.post(
      `${urlPre}/evaluation/evaluationApply/downloadEvaluationCommission`,
      params,
      {
        responseType: 'blob',
      }
    );
  },
  // 获取评价详情
  getEvaluationApplyDetail(params) {
    return request.post(
      `${urlPre}/evaluation/evaluationApply/getEvaluationApplyDetail`,
      params
    );
  },
  // 上传评价协议附件
  uploadCommissionAttachment: `${baseUrl}${urlPre}/evaluation/evaluationApply/uploadCommissionAttachment`,
  // 提交产品质量评价申请
  addEvaluationApplyCommissionInfo(params) {
    return request.post(
      `${urlPre}/evaluation/evaluationApply/addEvaluationApplyCommissionInfo`,
      params
    );
  },
  // 删除评价信息中的产品分项
  deleteEvaluationApplyItemPrice(params) {
    return request.post(
      `${urlPre}/evaluation/evaluationApply/deleteEvaluationApplyItemPrice`,
      params
    );
  },
  // 我的产品质量评价上传资料
  modifyStandardizedQualificationInfoSubmit(params) {
    return request.post(
      `${urlPre}/evaluation/evaluationApply/modifyStandardizedQualificationInfoSubmit`,
      params
    );
  },
  // 我的产品质量评价上传资料是否上传
  checkEvaluationApplyMaterialInfo(params) {
    return request.post(
      `${urlPre}/evaluation/evaluationApply/checkEvaluationApplyMaterialInfo`,
      params
    );
  },
  // 产品质量评价申请-是否开通在线支付-供应商
  checkIsOpenOnlinePay(params) {
    return request.post(
      `${urlPre}/evaluation/evaluationApply/checkIsOpenOnlinePay`,
      params
    );
  },
  // 产品质量评价申请-获取协议私有地址
  getOssPath(params) {
    return request.post(
      `${urlPre}/evaluation/evaluationApply/getOssPath`,
      params
    );
  },
  // 产品质量评价申请-单元分项评价-供应商
  addApplyItemPriceRate(params) {
    return request.post(
      `${urlPre}/evaluation/applyDetail/addApplyItemPriceRate`,
      params
    );
  },

  // 产品质量评价申请-下载报告
  downLoadEvaluationFile(params) {
    return request.post(
      `${urlPre}/evaluation/applyDetail/downLoadEvaluationFile`,
      params,
      {
        responseType: 'blob',
      }
    );
  },

  // 品牌图片上传
  fileUploadForBrand: `${baseUrl}${urlPre}/oss/fileUploadForBrand`,
  // 供应商资质上传
  fileUploadForLicence: `${baseUrl}${urlPre}/oss/fileUploadForLicence`,
  // 获取供应商资质
  getSupplierLicence(params) {
    return request.fetch(`${urlPre}/oss/getSupplierLicence`, params);
  },
  // 获取消息未读数量
  queryUnreadCount(params) {
    return request.fetch('/user-center/notice/queryUnreadCount', params);
  },
  // 查看消息
  readNotice(params) {
    return request.fetch('/user-center/notice/readNotice', params);
  },
  // 获取企业中心未读消息数量
  queryEaUnreadCount(params) {
    return request.fetch('/user-center/notice/queryEaUnreadCount', params);
  },
  // 查询用户申请状态
  queryUserApplyStatus(params) {
    return request.fetch(
      '/user-center/purchaseArea/queryUserApplyStatus',
      params
    );
  },
  // 查询拒绝原因
  queryRejectReason(params) {
    return request.fetch(
      '/cms/templateManagement/queryAuditReasonById',
      params
    );
  },
  // 非计划采购-插入或更新
  saveNotPlanPurchase(params) {
    return request.post(
      '/user-center/companyConfig/saveNotPlanPurchase',
      params
    );
  },
  // 查询非计划采购
  queryPlanPurchase(params) {
    return request.post('/user-center/companyConfig/queryPlanPurchase', params);
  },
  // 查询供应商信息列表
  getSupplierList(params) {
    return request.post(
      '/user-center/supplierManagement/querySupplierManagementInfoPage',
      params
    );
  },

  // 获取供应商评分
  getSupplierScore(params) {
    return request.fetch(
      '/user-center/supplierManagement/getSupplierScoreInfo',
      params
    );
  },
  // 保存供应商评分
  saveSupplierScore(params) {
    return request.post(
      '/user-center/supplierManagement/modifySupplierScoreInfo',
      params
    );
  },
  // 编辑保存供应商信息
  saveSupplierInfo(params) {
    return request.post(
      '/user-center/supplierManagement/modifySupplierManagementInfo',
      params
    );
  },
  // 获取运营方名称
  getCompanyInfo(params) {
    return request.fetch('/user-center/company/queryCompanyInfoById', params);
  }, //
  // 导出供应商列表
  downloadSupplierList(params) {
    return request.post(
      '/user-center/supplierManagement/exportSupplierInfo',
      params,
      {
        responseType: 'blob',
      }
    );
  },
  searchSupplierForStore(params) {
    return request.post('/user-center/search/searchSupplierForStore', params);
  },
  // 查询供应商产品目录
  querySupplierProductCatalogInfo(params) {
    return request.post(
      `/user-center/supplierManagement/querySupplierProductCatalogInfo?supplierId=${params}`
    );
  },
  // 查询供应商产简介及供应
  getSupplierOtherInfo(params) {
    return request.post(
      `/user-center/supplierManagement/getSupplierOtherInfo?supplierId=${params}`
    );
  },
  // 查询每日的PvUv
  queryBrandMallPvUv(params) {
    return request.fetch(
      '/data-center/supplierInfo/queryBrandMallPvUv',
      params
    );
  },
  // queryPuUvList: function(params) {
  //   return request.post("/data-center/dataCenter/queryPuUvList", params);
  // },
  // 查询供应商客户情况核心数据
  queryConsumerCore(params) {
    return request.fetch('/data-center/supplierInfo/queryConsumerCore', params);
  },
  // 查询供应商销售核心数据
  querySaleCore(params) {
    return request.fetch('/data-center/supplierInfo/querySaleCore', params);
  },
  // 查询供应商商品情况核心数据
  queryProductCore(params) {
    return request.fetch('/data-center/supplierInfo/queryProductCore', params);
  },
  // 查询供应商销售趋势分析数据
  querySaleMonth(params) {
    return request.fetch('/data-center/supplierInfo/querySaleMonth', params);
  },
  // 查询供应商商品销售规模地区排行数据
  querySaleProvince(params) {
    return request.fetch('/data-center/supplierInfo/querySaleProvince', params);
  },

  // 查询支付方式配置--企业运营后台前端调用
  queryOwnPaymentConfig(params) {
    return request.fetch(
      '/user-center/companyConfig/queryOwnPaymentConfig',
      params
    );
  },
  // 新增支付方式配置
  addPaymentConfig(params) {
    return request.post('/user-center/companyConfig/addPaymentConfig', params);
  },
  // 判断是否开通在线支付   判断供应商
  batchJudgeOnlinePayment(params) {
    return request.post('/user-center/company/batchJudgeOnlinePayment', params);
  },
  // 获取供应商资源详情
  queryCompanyDetail(params) {
    return request.post('/user-center/company/queryCompanyDetail', params);
  },
  // 订单取消配置项-插入或更新
  saveOrderCancelConfig(params) {
    return request.post(
      '/user-center/companyConfig/saveOrderCancelConfig',
      params
    );
  },
  // 订单取消配置项  查询
  queryOrderCancelConfig(params) {
    return request.post(
      '/user-center/companyConfig/queryOrderCancelConfig',
      params
    );
  },

  // 卡片相关接口
  // 卡片列表
  cardList(params) {
    return request.post('/user-center/staging/card/list', params);
  },
  // 获取用户卡片列表  查询
  userCardList(params) {
    return request.post('/user-center/staging/card/user/list', params, {
      preventRepeat: false,
    });
  },
  // 订单取消配置项  查询
  saveCardList(params) {
    return request.post('/user-center/staging/card/user/save', params);
  },
  // 获取新手引导标识
  noviceGuidance(params) {
    return request.post('/user-center/noviceGuidance/get/flag', params);
  },
  // 取消新手引导
  noviceGuidanceClose(params) {
    return request.post('/user-center/noviceGuidance/staging/close', params);
  },
  // 新增发票
  saveAndUpdateInvoiceManage(params) {
    return request.post(
      '/user-center/invoice/saveAndUpdateInvoiceManage',
      params
    );
  },
  getEvaluationApplyDetailNew(params) {
    return request.post(
      `${urlPre}/evaluation/applyDetail/getEvaluationApplyDetail`,
      params
    );
  },
};

export default server;
